// extracted by mini-css-extract-plugin
export default {"header":"Header_header__thnQ9","container":"Header_container__sdRQM"};